import React from "react";
import {ReturnTextAndImg} from "../CheckImg";
import "../test.css"

export default function RadioAnswer({data, name, value, changeRadioValue, isPassed, userAnswers}) {
    const styles = {
        right: {
            border: '3px solid rgba(128, 253, 195, 0.76)',
        },
        wrongUser: {
            border: '3px solid rgba(253, 128, 128, 0.76)',
        },
    }
    let style = isPassed ?
        data.percent > 0 ? styles.right :
            userAnswers[data.name] && data.percent <= 0 ?
                styles.wrongUser : null : null

    let text = ReturnTextAndImg(data.name);
    return (
        <label className="test-answer-general" style={style} key={'labelkey' + data.id}>
            <input className="radio" value={value} answername={data.name} name={`a${name}`} type="radio" style={{}}
                   onChange={(e) => {
                       changeRadioValue(e);
                   }} disabled={isPassed}/>
            {text}
        </label>
    )
}
